import { useState } from 'react'
import InputFormCard from '@component/InputFormCard'
import UnitAdornment from '@component/UnitAdornment'
import { TextField } from '@mui/material'
import { useHistoryList } from '@component/HistoryList'
import { useTranslation } from 'react-i18next'
import { Query } from '@core/query'
import { Controller } from 'react-hook-form'
import { useBasementWall } from './context'
import { makeFormRules } from '@/utils'

function isValidInputs (...values: number[]): boolean {
  let foundZero = false

  for (let i = 0; i < values.length; i += 1) {
    if (foundZero && +values[i] !== 0) {
      return false
    }

    if (+values[i] === 0) {
      foundZero = true
    }
  }

  return true
}

function BasementWallForm () {
  const { t } = useTranslation()
  const { form, setResult } = useBasementWall()
  const { appendHistory } = useHistoryList()

  const {
    control,
    reset,
    handleSubmit,
  } = form

  const rules = makeFormRules()

  const [isLoading, setLoading] = useState(false)
  const onSubmit = handleSubmit(async _ => {
    if (_.b1Height <= 0
      || isValidInputs(_.b1Height, _.b2Height, _.b3Height, _.b4Height, _.b5Height) === false) {
      alert(t('SENTENCE.CHECK_YOUR_INPUT'))
      return
    }

    setLoading(true)
    const res = await Query.requestCalcBasementWall(_)
    setLoading(false)

    setResult(res)
    appendHistory({
      type: 'BasementWall',
      ..._,
      result: res,
    })
  })

  const onReset = () => {
    reset()
    setResult(null)
  }

  return (
    <InputFormCard
      title={t('GLOSSARY.BASEMENT_WALL')}
      onReset={onReset}
      onSubmit={onSubmit}
      loading={isLoading}
    >
      <Controller
        control={control}
        name="b1Height"
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.B1_FLOOR_HEIGHT')}
            InputProps={{
              endAdornment: <UnitAdornment unit="m" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
      <Controller
        control={control}
        name="b2Height"
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.B2_FLOOR_HEIGHT')}
            InputProps={{
              endAdornment: <UnitAdornment unit="m" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
      <Controller
        control={control}
        name="b3Height"
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.B3_FLOOR_HEIGHT')}
            InputProps={{
              endAdornment: <UnitAdornment unit="m" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
      <Controller
        control={control}
        name="b4Height"
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.B4_FLOOR_HEIGHT')}
            InputProps={{
              endAdornment: <UnitAdornment unit="m" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
      <Controller
        control={control}
        name="b5Height"
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.B5_FLOOR_HEIGHT')}
            InputProps={{
              endAdornment: <UnitAdornment unit="m" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
    </InputFormCard>
  )
}

export default BasementWallForm
